import {
  Link as ChakraLink,
  type LinkProps as ChakraLinkProps
} from "@chakra-ui/react";

export type LinkProps = ChakraLinkProps;

export function Link(props: LinkProps) {
  return <ChakraLink {...props} />;
}
